import { CheckboxGroup as BaseCheckboxGroup } from "@base-ui/react/checkbox-group";
import { Field } from "@base-ui/react/field";
import { Fieldset } from "@base-ui/react/fieldset";
import type React from "react";
import { forwardRef } from "react";
import { vars } from "../../theme/theme.css";
import {
  errorSlotClass,
  errorSlotInnerClass,
  fieldInfoContainerClass,
} from "../FieldInfo/styles.css";
import {
  checkboxGroupFieldsetClass,
  checkboxGroupItemsClass,
  checkboxGroupLegendClass,
  checkboxGroupRootClass,
} from "./styles.css";

interface CheckboxGroupProps {
  legend?: React.ReactNode;
  value?: string[];
  defaultValue?: string[];
  onValueChange?: (value: string[]) => void;
  disabled?: boolean;
  error?: React.ReactNode;
  name?: string;
  allValues?: string[];
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const CheckboxGroup = forwardRef<HTMLDivElement, CheckboxGroupProps>(
  function CheckboxGroup(
    {
      legend,
      value,
      defaultValue,
      onValueChange,
      disabled,
      error,
      allValues,
      children,
      className,
      style,
    },
    ref,
  ) {
    return (
      <Field.Root
        ref={ref}
        invalid={!!error}
        className={`${checkboxGroupRootClass}${className ? ` ${className}` : ""}`}
        style={style}
      >
        <Fieldset.Root
          className={checkboxGroupFieldsetClass}
          disabled={disabled}
        >
          {legend && (
            <Fieldset.Legend className={checkboxGroupLegendClass}>
              {legend}
            </Fieldset.Legend>
          )}
          <BaseCheckboxGroup
            value={value}
            defaultValue={defaultValue}
            onValueChange={onValueChange}
            allValues={allValues}
            disabled={disabled}
            className={checkboxGroupItemsClass}
          >
            {children}
          </BaseCheckboxGroup>
        </Fieldset.Root>
        <div className={errorSlotClass} data-visible={error ? "true" : "false"}>
          <div className={errorSlotInnerClass}>
            <Field.Error
              className={fieldInfoContainerClass}
              style={{
                color: vars.colors.red.default,
                opacity: 1,
                transform: "none",
              }}
            >
              {error}
            </Field.Error>
          </div>
        </div>
      </Field.Root>
    );
  },
);

CheckboxGroup.displayName = "CheckboxGroup";
